//I Would Highly Recommend You To Customize The Theme According To Your Taste.
export const globalStyles = {
  "--grad": "linear-gradient(315deg,#48a9fe,#00cdac)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #48a9fe 0%, #734ae8 74%)", // Use gradients only
  // "--grad": "linear-gradient(315deg, #06bcfb 0%, #4884ee 74%)",
  "--txtcolor": "#272341",
  "--p_color": "#00cdac",
  "--s_color": "#fff",
};

// Navigation Bar Name
export const navbar_name = "<Sarb>";

// Main Page
export const main = {
  name: "Sarbjot Singh",
  doamin: "A MERN Stack Web Developer",
  resume:
    "https://drive.google.com/file/d/1GAeuiADThltf5dUOUFCmP9sGnFDTQrid/view?usp=sharing",
};

// AboutMe
export const aboutme = {
  imgLink:
    "https://avatars.githubusercontent.com/u/89245522?s=400&u=b4bbb0e678f29a3d29d23c060a2699fef1d0065a&v=4",
  p1: "Hey, My name is Sarbjot Singh. I have completed my Bachelor in Computer from Thapar University Patiala",
  p2: " I'm a passionate coder and an enthusiastic Web Developer capable of applying programming skills to solve complex problems. Seeking a challenging role in the field of software development that will offer an opportunity for further development of my abilities, skills and knowledge in an organization.",
  p3: "Apart from coding I also like to solve puzzle, travelling, read books and explore new things.",
};

// Skills
export const whatido = {
  title: "Full Stack Development",

  details: [
    "Building responsive website using MERN Stack",
    "Creating backend application in Node, ExpressJS",
    "Building Simple RESTful CRUD APIs",
    "Knowledge of MongoDB Database",
    "Knowledge of various UI libraries",
  ],
  logos: [
    {
      name: "HTML5",
      iconifyClassName: "vscode-icons:file-type-html", // PS : Use iconify class name
      id: "1",
    },
    {
      name: "CSS",
      iconifyClassName: "vscode-icons:file-type-css",
      id: "2",
    },
    {
      name: "JavaScript",
      iconifyClassName: "logos:javascript",
      id: "3",
    },
    {
      name: "ReactJS",
      iconifyClassName: "vscode-icons:file-type-reactjs",
      id: "4",
    },
    {
      name: "Redux",
      iconifyClassName: "logos:redux",
      id: "5",
    },
    {
      name: "NodeJS",
      iconifyClassName: "logos:nodejs",
      id: "6",
    },
    {
      name: "ExpressJS",
      iconifyClassName: "logos:express",
      id: "7",
    },
    {
      name: "MongoDB",
      iconifyClassName: "logos:mongodb",
      id: "8",
    },
    {
      name: "Chakra UI",
      color: "#65c9cb",
      iconifyClassName: "simple-icons:chakraui",
      id: "12",
    },
    {
      name: "Postman",
      iconifyClassName: "logos:postman-icon",
      id: "9",
    },
    {
      name: "npm",
      iconifyClassName: "logos:npm-icon",
      id: "10",
    },
    {
      name: "GIT",
      iconifyClassName: "logos:git",
      id: "11",
    },
    {
      name: "Material-UI",
      iconifyClassName: "logos:material-ui",
      id: "13",
    },
    {
      name: "Ant Design",
      iconifyClassName: "logos:ant-design",
      id: "14",
    },
    {
      name: "Netlify",
      iconifyClassName: "vscode-icons:file-type-netlify",
      id: "15",
    },
    {
      name: "Vercel",
      iconifyClassName: "logos:vercel-icon",
      id: "16",
    },
  ],
};

// Project Details
export const details = [
  {
    tags: ["REACT", "MERN", "ALL"],
    id: 1,
    title: "Fraazo Website Clone",
    desc: `Fraazo is an  online store to buy fresh fruits and vegetables.`,
    feature: `Sign-up validation with backend,
    Searching with Debouncing feature,
Pop and Toast notification.`,
    tech: `Tech Stack: Reactjs | ChakraUI | JavaScript | nodeJS | REST api`,
    img: "https://github.com/shriram083/Fraazo-Clone/blob/master/client/screenshots/HomePage.png?raw=true",
    github: "https://github.com/shriram083/Fraazo-Clone",
    stacks: "React| Chakra UI| CSS, JavaScript| NodeJS| Express| MongoDB",
    link: "https://fraazo-sarb.netlify.app/",
    vid: "https://drive.google.com/file/d/1e03bEP9pHxBWUmtbf6hAu8GlxHkU3lqm/view",
  },
  {
    tags: ["REACT", "MERN", "ALL"],
    id: 7,
    title: "Milaap Website Clone",
    desc: `Milaap is an online crowdfunding platform that enables anyone across India to raise funds.`,
    feature: `filtering, sorting & Searching products,
Google Oauth,
Stripe Payment. `,
    tech: `Tech Stack: Reactjs | ChakraUI | Express | MongoDB`,
    img: "https://github.com/sarb908/MilaapClone/raw/main/client/src/assets/milaap-screenshots/homePage.png?raw=true",
    github: "https://github.com/sarb908/MilaapClone",
    stacks: "React| Chakra UI| CSS, JavaScript| NodeJS| Express| MongoDB",
    link: "https://milaap-app-clone.netlify.app/",
    vid: "https://drive.google.com/file/d/12Zz7-Qlz9uU7bGvLpsuznUWMgRkkNODF/view",
  },
  {
    tags: ["HTML", "ALL"],
    id: 2,
    title: "Shopbop Website Clone",
    desc: `ShopBop is an e-commerce company, It sells beauty, wellness and fashion products.`,
    feature: `Sign-in/Sign-up,
Products Filter/Sort,
corousel image.`,
    tech: `Tech Stack: HTML | CSS | JavaScript `,
    img: "https://camo.githubusercontent.com/eb9744910653f38063615c2105cdc41f2bf24f79a9831001d717bf83a4c6b507/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f313430302f312a57373230716636496354596574615a354e386e5864672e706e67",
    link: "https://shopbop009.netlify.app/",
    github: "https://github.com/sarb908/ShopBop",
    stacks: "CSS, JavaScript, HTML",
    vid: "https://drive.google.com/file/d/1KD-5bAcZFg3PF18NAC0v5vvwA9kmBeMR/view",
  },

  {
    tags: ["HTML", "ALL"],
    id: 3,
    title: "ShopDisney Website Clone",
    desc: `Nykaa is an e-commerce company, It sells beauty, wellness and fashion products across websites.`,
    feature: `Sliding component,
Sign-in/Sign-up validation ,
    corousel image.`,
    tech: `Tech Stack: HTML | CSS | JavaScript .`,
    img: "https://user-images.githubusercontent.com/98751679/161430944-f53ce797-14e8-4017-9d36-edbe7a3c804c.jpg",
    link: "https://fascinating-kelpie-746297.netlify.app",
    github: "https://github.com/shreymishra27/Unit-2-Project",
    stacks: `HTML, CSS, JavaScript`,
    vid: "https://drive.google.com/file/d/1coxELlZQ4UN-tCXjgClwDPnjkaG0jnT8/view",
  },
];

// Social Media Links
export const links = [
  "https://www.linkedin.com/in/sarbjot-/",
  // "https://api.whatsapp.com/send/?phone=918109560498&text&app_absent=0",
  "mailto:sarbjots908@gmail.com",
  "https://github.com/sarb908",
];
